import React, { useState, useEffect } from 'react';
import { notification, Skeleton } from 'antd';

import CitiesForm from '../../../containers/CitiesForm/index';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';

import { post, put, get } from '../../../api/module/cities';

import './style.scss';

const CitiesForms = ({ history, match }) => {
  const [cityID] = useState(parseInt(match.params.id));
  const [title, setTitle] = useState('Creación de Ciudades');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const save = async (data) => {
    try {
      let response;
      setLoading(true);

      if (!cityID) {
        response = await post(data);
      } else {
        response = await put(cityID, data);
      }

      setLoading(false);

      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(INTERNAL_LINKS.CITIES);
        }, MESSAGES.TIME);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);

      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
    }
  };

  const handleGet = async () => {
    try {
      if (cityID) {
        const response = await get(cityID);
        setData(response.data);
        setTitle('Actualización de Ciudades');
      } else {
        setData({});
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  };

  useEffect(() => {
    handleGet();
  }, []);

  return (
    <Skeleton loading={data === null}>
      <CitiesForm
        title={title}
        onFinish={save}
        initialValues={data}
        loading={loading}
      />
    </Skeleton>
  );
};

export default CitiesForms;
